import { ApiBase } from '../types/core.types';
import { ValidateQRRequest, ValidateQRCodeRequest, QRValidateResponse, QRVerifyResponse } from '../types/qr.types';

const BASE_URL = 'qr';

export class QrApi extends ApiBase {
  public async validate(request: ValidateQRRequest): Promise<QRValidateResponse> {
    try {
      const response = await this.apiClient.post(`${BASE_URL}/validate`, request);
      return {
        isSuccess: response.data?.isSuccess || false,
        message: response.data?.message,
        data: response.data?.data || false,
      };
    } catch (error: any) {
      return {
        isSuccess: false,
        message: error.response?.data?.message,
        data: false,
      };
    }
  }

  public async verifyCode(request: ValidateQRCodeRequest): Promise<QRVerifyResponse> {
    try {
      const response = await this.apiClient.post(`${BASE_URL}/verify-code`, request);
      const { data } = response;

      if (data.isSuccess && data.data?.success && data.data?.pdfBuffer) {
        // Başarılı durumda PDF buffer'dan blob oluştur
        // pdfBuffer format: {type: "Buffer", data: [37, 80, ...]}
        const bufferArray = data.data.pdfBuffer.data;
        const blob = new Blob([new Uint8Array(bufferArray)], { type: 'application/pdf' });
        return {
          isSuccess: true,
          data: blob,
        };
      }

      return {
        isSuccess: false,
        message: data.data?.message,
      };
    } catch (error: any) {
      return {
        isSuccess: false,
        message: error.response?.data?.message || error.message,
      };
    }
  }
}
